import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { clientService } from '../services/clientService';
import { format } from 'date-fns';

export const useClientDetails = () => {
    const { id } = useParams();

    const {
        data: client,
        isLoading,
        error,
        refetch,
    } = useQuery({
        queryKey: ['clientDetails', id],
        queryFn: () => clientService.getClientById(id).then(res => res.data.data),
        staleTime: 1000 * 60 * 5,
        enabled: !!id,
    });

    const formattedClient = client ? {
        id: client.id,
        fullName: `${client.title ? client.title + ' ' : ''}${client.first_name} ${client.last_name}`.trim(),
        companyName: client.company_name || null,
        email: client.email,
        phone: client.phone,
        tag: client.company_name ? 'Corporate' : 'Individual',
        status: client.user?.role === 'admin' ? 'Active' : 'Lead',
        clientSince: client.created_at ? format(new Date(client.created_at), 'MMM d, yyyy') : '—',

        street1: client.street_1 || '',
        street2: client.street_2 || '',
        city: client.city?.name || '—',
        state: client.state?.name || '—',
        postalCode: client.postal_code || '—',
        country: client.country || '—',

        fullAddress: [
            [client.street_1, client.street_2].filter(Boolean).join(', '),
            client.city?.name,
            client.state?.name,
            client.postal_code,
            client.country
        ].filter(Boolean).join(', ') || 'No address provided',

        raw: client,
    } : null;

    return {
        client: formattedClient,
        isLoading,
        error,
        refetch,
    };
};